export default [
  {
    header: "الدعم التقني ",
    icon: "MoreHorizontalIcon",
    children: [
      {
        title: "إدارة المستخدمين ",
        route: "users",
        icon: "UsersIcon",
        slug:'ngo_users'
      },
    ],
  },
];
